import store from 'shared/store'
import { isSaeOffer } from 'views/components/organisms/FilteredProductList/SearchProductListItem/helpers'

import {
  changeVisibilitySubscriptionElements,
  getSubscriptionElements,
} from './helpers'

export * from './helpers'
export default userSession => {
  const { subscriptionService, isLoggedIn } = userSession || {}
  const {
    pageProperties: {
      bestOffer,
      experiments,
      isSubscriptionProduct,
      productStockStatus,
    },
    publicConfig: { tenant },
  } = store.getPublicRuntimeConfig()
  const {
    buyboxSubscriptionLink,
    buyboxPersonalAdviceLink,
    productDescriptionPersonalAdviceLink,
    productLabelAboElement,
    headerAboLink,
  } = getSubscriptionElements()

  const isSaeProduct = isSaeOffer({
    bestOffer,
    experiments,
    tenant,
  })

  changeVisibilitySubscriptionElements({
    buyboxSubscriptionLink,
    buyboxPersonalAdviceLink,
    productDescriptionPersonalAdviceLink,
    subscriptionService,
    isSubscriptionProduct: isSubscriptionProduct && isSaeProduct,
    productStockStatus,
    productLabelAboElement,
    headerAboLink,
    isLoggedIn,
  })
}
